import { RideTabsEnum } from "../../enums";
import type { ICustomField, IDropdownItem, IFormSchema } from "../../models";

/**
 * The ride drawer renders schema fields only on its Basic and Advanced tabs; the Map entry shows just the
 * map, and later entries (the seed's RestControls) only hand their controls to the form. Like RenderTemplate,
 * it also counts a field the role may not read as off the card.
 */
export const isRideFormFieldOnCard = ({
  formSchema,
  controls,
  fieldName,
  isFieldReadable,
}: {
  formSchema: IFormSchema | undefined;
  controls: Pick<ICustomField, "id" | "name" | "readPermission">[];
  fieldName: string;
  isFieldReadable: (readPermission: ICustomField["readPermission"]) => boolean;
}): boolean => {
  const control = controls.find(({ name }) => name === fieldName);
  const controlId = control?.id;

  if (!controlId || !isFieldReadable(control?.readPermission)) {
    return false;
  }

  return (formSchema?.layout ?? [])
    .slice(0, RideTabsEnum.Advanced + 1)
    .some(({ fieldIds }) => fieldIds?.includes(controlId) ?? false);
};

/** The active admin row the logged-in user owns, as a value the referent dropdown can show. */
export const findUserSystemManagerId = ({
  systemManagers,
  userId,
}: {
  systemManagers: IDropdownItem[];
  userId: number | undefined;
}): number | undefined => {
  if (!userId) {
    return undefined;
  }

  const systemManager = systemManagers.find(
    item => item.userId === userId && item.isActive !== false,
  );

  return systemManager ? Number(systemManager.value) : undefined;
};
